/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { forwardRef, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/Squiggle_Logo_White.png";
import DefaultImage from "../../../assets/images/Squiggle_S_Square_Green.png";

import { Divider, Typography } from "@mui/material";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { useThemeContext } from "../../../contexts/theme";
import {
  IMG_BASE_URL,
  USER_ROLE,
  sideBarWithIconAndName,
} from "../../../utils/constant";
import {
  hideShowCommissionMenu,
  includesStringFromArray,
} from "../../../utils/util";
import HierarchicalManageMenu from "./Hierarchical_Menu";
import {useSecureUrl} from "../../../hooks/useSecureHook"

const SideBar = forwardRef((props, ref) => {
  const themeObj = useThemeContext();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.currentUser);
  const userDetails = useSelector((state) => state?.auth?.currentUser);
  const [t] = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [activeItemKey, setActiveItemKey] = useState(null);
  const [openMenu, setOpenMenu] = useState({
    withLabel: false,
    withoutLabel: false,
  });

  const getThemedTextColor = () => {
    return themeObj.theme === "light" ? "text-dark" : "text-white";
  };

  const getThemedBgColor = () => {
    return "bg-light"; // This was already consistent in original
  };

  const onClickMenuItem = (key) => {
    if (window.screen.width && window.screen.width < 600) {
      toggleSidebar();
    }
    setActiveItemKey(key);
  };

  const toggleSidebar = () => {
    if (ref.current?.classList.contains("sb-active")) {
      ref.current.classList.remove("sb-active");
    } else {
      ref.current?.classList.add("sb-active");
    }
  };

  const handleClickOpenProfileOptions = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseProfileOptions = () => {
    setAnchorEl(null);
  };

  const handleNavigateToProfilePage = () => {
    navigate("/app/profile");
    setAnchorEl(null);
    setActiveItemKey(null);
  };

  const handleNavigateToTechSupportPage = () => {
    navigate("/app/tech-support");
    setAnchorEl(null);
    setActiveItemKey(null);
  };

  const handleNavigateToCommissionPage = () => {
    navigate("/app/commissions/list");
    setAnchorEl(null);
    setActiveItemKey(null);
  };

  const handleClickMenuWithlabel = (path) => {
    navigate(path);
    setOpenMenu({ withLabel: false, withoutLabel: false });
  };

  const handleClick = (key) => {
    setActiveItemKey(key);
  };

  const handleLogout = () => {
    Cookies.remove("jwt-token");
    navigate("/login");
  };

  const openMenuwithoutLabel = (item) => {
    if (item?.isManage) {
      setOpenMenu({
        ...openMenu,
        withoutLabel: true,
      });
    }
  };

  const openMenuwithLabel = (item) => {
    if (item?.isManage) {
      setOpenMenu({
        ...openMenu,
        withLabel: true,
      });
    }
  };

  // Set active item for dashboard route
  useEffect(() => {
    if (location.pathname === "/app/dashboard") {
      setActiveItemKey("routekey-home");
    }
  }, [location.pathname]);



  // Helper function to get user profile image
  const getUserProfileImage = () => {
    if (user?.type === "Internal") {
      return user?.profilePhotoUrl || DefaultImage;
    }

    if (user?.profilePhotoUrl) {
      if (user.profilePhotoUrl.startsWith("https")) {
        return user.profilePhotoUrl;
      }
      return `${process.env.REACT_APP_API_PATH}${IMG_BASE_URL}${user.profilePhotoUrl}`;
    }

    return DefaultImage;
  };

  ////
    const src = useSecureUrl(useMemo(() => getUserProfileImage(), []));

  // Helper function to check if item should be active
  const isItemActive = (item) => {
    return (
      (item?.path === location?.pathname || item?.path === "#") &&
      item?.key === activeItemKey
    );
  };

  // Helper function to get active item styles
  const getActiveItemStyles = (item) => {
    const isActive = isItemActive(item);
    return {
      height: "64px",
      width: isActive ? "215px" : "",
      backgroundColor: isActive ? "#00ce3f" : "",
      borderTopRightRadius: isActive ? "50px" : "",
      borderBottomRightRadius: isActive ? "50px" : "",
      fontWeight: item?.path === location?.pathname ? "bold" : "",
      zIndex: item?.path === location?.pathname ? 1 : "",
      display: hideShowCommissionMenu(item, userDetails),
    };
  };

  // Check if sidebar should be rendered
  const shouldRenderSidebar = () => {
    const excludedPaths = ["/forms/", "/configure-task"];
    const hasExcludedPath = excludedPaths.some((path) =>
      location.pathname.includes(path)
    );
    return !hasExcludedPath;
  };

  const isIconOnlyView = includesStringFromArray(
    location.pathname,
    sideBarWithIconAndName
  );

  if (!shouldRenderSidebar()) {
    return null;
  }

  return (
    <div className="d-flex align-content-start h-100">
      <nav
        ref={ref}
        className={`h-100 ${
          isIconOnlyView ? "sidebar_instruction_dashboard" : "sidebar"
        } ${getThemedTextColor()} ${getThemedBgColor()}`}
        style={{
          height:
            location.pathname.includes("/app/manage") ||
            location.pathname.includes("/app")
              ? `${window.innerHeight + 160}px`
              : "",
        }}
      >
        {/* Logo */}
        <a
          href="/"
          className={`d-flex mb-md-0 me-md-auto ${getThemedTextColor()} text-decoration-none`}
        >
          <span
            className={`fs-4 ${
              isIconOnlyView ? "px-1 py-1" : "px-3 py-1"
            } mb-4 ${isIconOnlyView ? "mt-1" : "mt-3"}`}
          >
            <img
              src={isIconOnlyView ? DefaultImage : Logo}
              alt="website_logo"
              style={{ height: "60px" }}
            />
          </span>
        </a>

        {/* Navigation Items */}
        <ul className="nav flex-column mb-auto">
          {props?.sidebarMenu?.map((item) => {
            if (item.subMenu) return null;

            return (
              <li
                key={item.key}
                className="nav-item m-2"
                onClick={() => onClickMenuItem(item?.key)}
                style={
                  isIconOnlyView
                    ? getActiveItemStyles(item)
                    : {
                        width: isItemActive(item) ? "213px" : "",
                        backgroundColor: isItemActive(item) ? "#00ce3f" : "",
                        borderTopRightRadius: isItemActive(item) ? "50px" : "",
                        borderBottomRightRadius: isItemActive(item)
                          ? "50px"
                          : "",
                        fontFamily:
                          item?.path === location?.pathname
                            ? "Manrope-Bold"
                            : "Manrope-Regular",
                        fontSize: "18px",
                        zIndex: item?.path === location?.pathname ? 1 : "",
                        display: hideShowCommissionMenu(item, userDetails),
                      }
                }
              >
                <NavLink
                  to={item.path || "#"}
                  className={`nav-link text-start ${getThemedTextColor()} ${
                    item.visibleOnSmallScreen ? "" : "d-none d-md-block"
                  }`}
                  aria-current="page"
                >
                  <span
                    className="sidebar_Icons"
                    style={{
                      color: isIconOnlyView ? "#FFF" : "white",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                    onClick={() =>
                      isIconOnlyView
                        ? openMenuwithoutLabel(item)
                        : openMenuwithLabel(item)
                    }
                  >
                    {item?.isManage ? (
                      item?.icon
                    ) : (
                      <img src={item.icon} alt="squiggle" />
                    )}
                    {!isIconOnlyView && t(item.label)}
                  </span>
                </NavLink>
              </li>
            );
          })}
        </ul>

        {/* Hierarchical Menu */}
        <HierarchicalManageMenu
          open={isIconOnlyView ? openMenu.withoutLabel : openMenu.withLabel}
          onClose={() =>
            setOpenMenu({
              ...openMenu,
              [isIconOnlyView ? "withoutLabel" : "withLabel"]: false,
            })
          }
          handleClickMenuWithlabel={handleClickMenuWithlabel}
          isIconOnly={isIconOnlyView}
          activeItemKey={activeItemKey}
          Location={location}
          style={{
            marginLeft: isIconOnlyView ? "4.5rem" : "12.5rem",
            marginTop: isIconOnlyView ? "16rem" : "14rem",
          }}
        />

        {/* Profile Section */}
        <ul
          style={{
            position: "absolute",
            bottom: 0,
            width: isIconOnlyView ? "70px" : "208px",
            backgroundColor: "#3D4740",
            height: "90px",
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 1,
          }}
          className="nav flex-column mb-auto"
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickOpenProfileOptions}
        >
          <li className={`nav-item ${isIconOnlyView ? "" : "m-2"}`}>
            <NavLink className="nav-link text-center" aria-current="page">
              <span
                className={isIconOnlyView ? "" : "nav-label"}
                style={{
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isIconOnlyView ? "center" : "flex-start",
                }}
              >
                {/* <Avatar
                  sx={{
                    border: "2px solid #00CE3F",
                    // height: isIconOnlyView ? "auto" : "52px",
                    // width: isIconOnlyView ? "auto" : "52px",
                  }}
                  src={getUserProfileImage()}
                /> */}

                <Avatar sx={{ border: "2px solid #00CE3F" }} src={src} />

                


                {!isIconOnlyView && (
                  <Typography
                    sx={{
                      marginLeft: "1rem",
                      marginTop: "0.2rem",
                    }}
                  >
                    {`${user?.firstName || ""} ${user?.lastName || ""}`.trim()}
                  </Typography>
                )}
              </span>
            </NavLink>
          </li>
        </ul>

        {/* Profile Menu */}
        <Menu
          slotProps={{
            paper: {
              sx: { borderRadius: "24px" },
            },
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleCloseProfileOptions}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          style={{ marginLeft: "0.5rem" }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          sx={{
            "& .MuiList-root": {
              background: "#3D4740",
              opacity: 0.9,
              color: "white",
            },
          }}
        >
          <MenuItem onClick={handleNavigateToProfilePage}>My Account</MenuItem>

          {userDetails?.role !== USER_ROLE?.INTRODUCER && (
            <MenuItem onClick={handleNavigateToTechSupportPage}>
              Tech Support
            </MenuItem>
          )}

          {userDetails?.role === USER_ROLE?.CONSULTANT && (
            <MenuItem onClick={handleNavigateToCommissionPage}>
              My Commissions
            </MenuItem>
          )}

          <MenuItem className="green" onClick={handleLogout}>
            Logout
          </MenuItem>
        </Menu>
      </nav>
    </div>
  );
});

export default SideBar;
